import { render, staticRenderFns } from "./CompanyDetailsDialog.vue?vue&type=template&id=94773b6e"
import script from "./CompanyDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./CompanyDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetailsDialog.vue?vue&type=style&index=0&id=94773b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports